// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EyeInvisibleTwoToneSvg from "@fishx/icons-svg/es/asn/EyeInvisibleTwoTone";
import FishxIcon from '../components/FishxIcon';

var EyeInvisibleTwoTone = function EyeInvisibleTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: EyeInvisibleTwoToneSvg
  }));
};

EyeInvisibleTwoTone.displayName = 'EyeInvisibleTwoTone';
export default React.forwardRef(EyeInvisibleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/EyeInvisibleTwoTone.js
// module id = 2658
// module chunks = 0